export default __webpack_public_path__ + "static/media/jioglass-lp-bg.0a79b442.jpg";